import { Component, OnInit, ChangeDetectionStrategy, Input, AfterViewInit, EventEmitter, Output, QueryList, ViewChildren, ChangeDetectorRef } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Guid } from 'guid-typescript';
import { WorkItemModel } from '../../models/work-item';
import { E5coreUiAssignUserBaseComponent } from './component/e5core-ui-work-assign-user-base';
import { WorkItemFoundationService } from 'e5core-angular-services';
import { WorkUserEvent } from '../../events/work-user-event';
import { UserModel } from 'e5core-angular-services';
import { UiStyleService } from '../../services/ui-style.service';

@Component({
  selector: 'e5core-ui-work-assign-user',
  template: `
  <span *ngIf="workItem$" [ngSwitch]="style.current()">
  <e5core-ui-work-assign-user-box *ngSwitchCase='0' [showAssignButton]='showAssignButton' [loading]='loading' [readonly]='readonly' (selectUserEvent)='selectUser($event)' (assignUserEvent)='assignUser($event)'></e5core-ui-work-assign-user-box>
  <e5core-ui-work-assign-user-bootstrap *ngSwitchCase='1' [showAssignButton]='showAssignButton' [loading]='loading' [readonly]='readonly' (selectUserEvent)='selectUser($event)' (assignUserEvent)='assignUser($event)'></e5core-ui-work-assign-user-bootstrap>
  <e5core-ui-work-assign-user-material *ngSwitchCase='2' [showAssignButton]='showAssignButton' [loading]='loading' [readonly]='readonly' (selectUserEvent)='selectUser($event)' (assignUserEvent)='assignUser($event)'></e5core-ui-work-assign-user-material>
  </span>
  <div *ngIf="!(workItem$)" class="e5core-component-error">&lt;e5core-ui-work-assign-user&gt; [workItem$] must have a BehaviorSubject&lt;WorkItemModel&gt;</div>`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class E5coreUiAssignUserComponent implements AfterViewInit, OnInit {

  @Input() workItem$: BehaviorSubject<WorkItemModel>;
  @Input() showAssignButton: boolean = true;
  @Input() readonly: boolean = false;
  @Output() assignUserEvent = new EventEmitter<WorkUserEvent>();
  @Output() selectUserEvent = new EventEmitter<WorkUserEvent>();

  public selectedUser: UserModel;
  public loading: boolean = false ;
  
  @ViewChildren(E5coreUiAssignUserBaseComponent)
  public assignUserComponents: QueryList<E5coreUiAssignUserBaseComponent>;

  constructor(
    public style:UiStyleService,
    private workItemFoundationService: WorkItemFoundationService,
    private changeDetectorRef: ChangeDetectorRef
  ) { }

  ngOnInit() {
    if (typeof this.workItem$ == 'undefined') {
      console.error('e5core-ui-work-assign-user [workItem$] must have a BehaviorSubject<WorkItemModel>');
      return;
    }

    if (typeof this.workItem$ != 'undefined') {
      this.workItem$.subscribe(
        wim => {
          if (wim.workId && wim.workId != Guid.EMPTY) {
            this.populateAssignableUsers(wim.workId);
          }
        }
      )
    }
  }

  public populateAssignableUsers(wid: string) {
    this.loading = true;
    this.changeDetectorRef.detectChanges();
    this.workItemFoundationService.getAssignableUsers(wid).subscribe(
      s => {
        this.assignUserComponents.forEach(element => {
          element.users = s;
          this.loading = false;
          this.changeDetectorRef.detectChanges();
        });
      },
      error => {
        console.error(error);
      }
    )
  }

  public selectUser(event): void {
    this.selectedUser = event.value;
    var wid = this.workItem$.getValue().workId;

    this.selectUserEvent.emit({workId: wid, id: this.selectedUser.id, login: this.selectedUser.userName, name: this.selectedUser.name, email: this.selectedUser.email});
  }

  public assignUser(event): void {
    if (this.selectedUser) {

      var assignUserJson = {
        AssignedUser: this.selectedUser.userName
      };

      var wid = this.workItem$.getValue().workId;

      this.workItemFoundationService.update(wid, assignUserJson).subscribe(
        s => {
          if (typeof this.workItem$ != "undefined") {
            this.workItem$.next(this.workItem$.getValue());
          }
          this.assignUserEvent.emit({workId: wid, id: this.selectedUser.id, login: this.selectedUser.userName, name: this.selectedUser.name, email: this.selectedUser.email});
        },
        error => {
          console.error(error);
          throw error;
        }
      )
    }
  }

  ngAfterViewInit() {
  }
}